var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-preview-diagnostic-step",on:{"click":_vm.handleClickOnStep}},[(_vm.redirection)?_c('div',{staticClass:"icon-wrapper"},[_c('font-awesome-icon',{staticClass:"key-step-icon my-auto mr-2",attrs:{"icon":['fa', 'external-link-square']}})],1):_vm._e(),_c('TextEllipsis',{attrs:{"text":_vm.label,"font-size":'14px'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }